import { useAuthenticationContext } from '../../contexts/AuthenticationContext';
import EmployeeLogin from '../../pages/EmployeeLogin'

const ProtectedAccess = ({children}) => {
    const { employeeAuthenticationData } = useAuthenticationContext()

    return employeeAuthenticationData.isAuthenticated ? children: <EmployeeLogin/>
}

export default ProtectedAccess